import { resources } from "@constants/hardcoded-strings";
import { OrganizationDetailsValidationErrors } from "@idw-types/common/validation/organization/organization-details/organization-details-validation-errors";
import { OrganizationConfig } from "@idw-types/data/organization-config";
import { getErrorAlert, getTabTitle } from "@utils/tab-util";

export const getOrganizationDetailsValidationErrors = (organizationConfig: OrganizationConfig): OrganizationDetailsValidationErrors => {
    let count = 0;
    let companyNameError = null;
    let companyCodeError = null;
    if(organizationConfig.name === ""){
        companyNameError = getErrorAlert(resources.common.requiredField);
        count++;
    }

    if (organizationConfig.permissions.canModifyCustomerSupportTier) {
        const codeLength = (organizationConfig.companyCode || "").length;
        if (codeLength > 16) {
            companyCodeError = getErrorAlert("Organization Code can be a maximum length of 16 characters");
            count++;
        }
    }
    
    return {
        count,
        details: {
            count,
            companyNameError,
            companyCodeError,
            tabTitle: getTabTitle(resources.pages.organizationDetails.tabs.details.tabName, count)
        }
    }
}